const localIp = "192.168.1.61";

let baseUrl = "https://www.familysos.it/api";
// baseUrl = "http://sosfamily-stage.molecle.com/api";
// baseUrl = `http://${localIp}:5000/api`;

let translationsUrl = "https://www.familysos.it/api";

let domain = "https://www.familysos.it";

let stripe_p = "pk_live_RoF6xRVdJ3A3gTNWc1SFktds";
//stripe_p = "pk_test_51Ix9UrDqjASEMHqVE4Vz3iVvLQumUiZpbiPsD1plfaf65zcpA4UT27QchplCrXeJUsfU8Ea6DVOIYGmgUL7vX4IL00slC9cZxL";

export const environment = {
  firebase: {
    apiKey:
      "AAAA4K78x2I:APA91bFVGYgmAyJLXIMwu7ZfvjBUdoOpifxmW3gwG4O8KFUNL0_WZLKDSGk-11MTtcxgnJHXKm6lhw6sCBvdUirmNH7Lw0TwWRe5BySqC0n3QlAQYWatVivU9A26SyXXqmAyH5bCJgzw",
    authDomain: "urmet-sos-family.firebaseio.com",
    databaseURL: "https://urmet-sos-family.firebaseio.com",
    projectId: "urmet-sos-family",
    storageBucket: "urmet-sos-family.appspot.com",
    messagingSenderId: "965008476002",
  },
  cloud: {
    baseUrl,
    domain,
    translationsUrl,
  },
  keystoneHttpClient: {
    isAuth: true,
    baseUrl,
  },
  stripe: {
    public: stripe_p,
  },
};



// WEBPACK FOOTER //
// ./src/app/environments/default.ts